import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="2wk9zanmsgt0o">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="28ufnm9e7hai0">
      La próxima consulta puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-purple/25 selection:text-brand-purpleDark bg-brand-surface" data-id="element-2" data-mp="3ik7jmqgv0tve">
      <UrgencyBanner data-id="element-3" data-mp="3mjzsz5e2v41t" />
      <Hero data-id="element-4" data-mp="3mjg8bgx1m1k3" />
      <InitialTestimonials data-id="element-5" data-mp="3mj6lu3b7icj5" />
      <PainPoints data-id="element-6" data-mp="3rbrcwx2qabiz" />
      <MethodOverview data-id="element-7" data-mp="3rdki07xp0nov" />
      <MaterialPreview data-id="element-8" data-mp="3rd19fhtxnbni" />
      <MoreTestimonials data-id="element-9" data-mp="5yjsutqtdfe" />
      <Guarantee data-id="element-10" data-mp="6htxpd5ixiv" />
      <FAQ data-id="element-11" data-mp="4wyzymxdckh" />
      <CostComparison data-id="element-12" data-mp="5gfrc0u9uwx" />
      <TransitionPhrase data-id="element-13" data-mp="82j0zgp5o9c" />
      <EmotionalClose data-id="element-14" data-mp="2zld2xbxu5jcl" />
      <Footer data-id="element-15" data-mp="2zlv32jnmchps" />
      <FloatingNotification data-id="element-16" data-mp="2zmenc70qri6z" />
    </div>;
}